const text = {
    title: 'Physics (greek characters)',
    characters: [
        {character: '𝛼', title: 'Alpha'},
        {character: '𝛽', title: 'Beta'},
        {character: '𝛄', title: 'Gamma'},
        {character: '𝛿', title: 'Delta (lowercase)'},
        {character: '𝛥', title: 'Delta (uppercase)'},
        {character: '𝜀', title: 'Epsilon'},
        {character: '𝜁', title: 'Zeta'},
        {character: '𝜂', title: 'Eta'},
        {character: '𝜃', title: 'Theta'},
        {character: '𝜅', title: 'Kappa'},
        {character: '𝜆', title: 'Lamda (lowercase)'},
        {character: '𝛬', title: 'Lamda (uppercase)'},
        {character: '𝜇', title: 'Mu'},
        {character: '𝜈', title: 'Nu'},
        {character: '𝜉', title: 'Xi'},
        {character: '𝜋', title: 'Pi'},
        {character: '𝜌', title: 'Rho'},
        {character: '𝜎', title: 'Sigma (lowercase)'},
        {character: '𝛴', title: 'Sigma (uppercase)'},
        {character: '𝜏', title: 'Tau'},
        {character: '𝜑', title: 'Phi (lowercase)'},
        {character: '𝛷', title: 'Phi (uppercase)'},
        {character: '𝛹', title: 'Psi'},
        {character: '𝜔', title: 'Omega (lowercase)'},
        {character: '𝛺', title: 'Omega (uppercase)'},
    ]
}

export default text